module.exports = __webpack_public_path__ + "img/adb1ece.jpg";